module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAP1BMVEUAAAAAudEAus8AvtEAv8wAvM4Avc4Avc4Avc4Avc4Avc4Avc4Avc4Avc4Avc0Avc4Avc4VwtKr6e/n+fr///+QB4otAAAAEHRSTlMAFiUnKFSmq63p6uvv8fLznBn92gAAAJVJREFUOMvt1c0OgyAQBOBZEdlasaPy/s/aQ09ri1ltDz0wF/6+BEjIArS8p9PMSrJ21oaJB5mCwcpBapvKQDUTmVI/ovBhxuTRhXarF3D9it/iV6+UUuzy/+NtXTc3XsjFjZkS3fguMrpxBKIXJwBIPjwKAMjNhaNpfvVEG76ATxWZU+WrPy6M/a6M6lyjs4b2JX3IE8QYFb9fMMwXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/course/keczx@2x.png
// module id = lDd/
// module chunks = 0